/**
 * @generated SignedSource<<6c97ea8c844ed187b5170e04f7139e59>>
 * @relayHash acc9e1f75d9018f5e58bb0b4864d2056
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e980b42c3e7b17ffb2bfcac6e3408576937ef6e0808f9af61b03ee9a4dd538eb

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type AggGoalTabContentQuery$variables = {
  containerId: string;
  goalKey: string;
  isDecisionsTab: boolean;
  isJiraAlignTab: boolean;
  isJiraTab: boolean;
  isLearningsTab: boolean;
  isProjectsTab: boolean;
  isRisksTab: boolean;
  isUpdatesTab: boolean;
  queryContext?: string | null;
};
export type AggGoalTabContentQuery$data = {
  readonly goals_byKey: {
    readonly " $fragmentSpreads": FragmentRefs<"AggGoalUpdatesTabContent" | "GoalContentAbout" | "GoalContentDecisions" | "GoalContentJira" | "GoalContentJiraAlign" | "GoalContentLearnings" | "GoalContentProjects" | "GoalContentRisks">;
  } | null;
};
export type AggGoalTabContentQuery = {
  response: AggGoalTabContentQuery$data;
  variables: AggGoalTabContentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "containerId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "goalKey"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isDecisionsTab"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isJiraAlignTab"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isJiraTab"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isLearningsTab"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isProjectsTab"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isRisksTab"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isUpdatesTab"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "queryContext"
},
v10 = [
  {
    "kind": "Variable",
    "name": "containerId",
    "variableName": "containerId"
  },
  {
    "kind": "Variable",
    "name": "goalKey",
    "variableName": "goalKey"
  }
],
v11 = {
  "kind": "Variable",
  "name": "queryContext",
  "variableName": "queryContext"
},
v12 = [
  (v11/*: any*/)
],
v13 = {
  "kind": "ScalarField",
  "name": "id"
},
v14 = {
  "kind": "ScalarField",
  "name": "description"
},
v15 = {
  "kind": "ScalarField",
  "name": "canEditMetrics"
},
v16 = {
  "kind": "ScalarField",
  "name": "canManagePeriodicMetricTargets"
},
v17 = {
  "kind": "ScalarField",
  "name": "canCreateGoal"
},
v18 = {
  "kind": "ScalarField",
  "name": "canCreateUpdates"
},
v19 = {
  "kind": "ScalarField",
  "name": "kind"
},
v20 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v21 = {
  "kind": "ScalarField",
  "name": "value"
},
v22 = [
  (v21/*: any*/)
],
v23 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "messageId"
    },
    {
      "kind": "ScalarField",
      "name": "defaultValue"
    }
  ],
  "type": "TownsquareLocalizationField"
},
v24 = {
  "kind": "LinkedField",
  "name": "name",
  "plural": false,
  "selections": [
    (v20/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": (v22/*: any*/),
      "type": "TownsquareGoalTypeCustomName"
    },
    (v23/*: any*/)
  ]
},
v25 = {
  "kind": "LinkedField",
  "name": "namePlural",
  "plural": false,
  "selections": [
    (v20/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": (v22/*: any*/),
      "type": "TownsquareGoalTypeCustomNamePlural"
    },
    (v23/*: any*/)
  ]
},
v26 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 50
  }
],
v27 = {
  "kind": "ScalarField",
  "name": "archived"
},
v28 = {
  "kind": "ScalarField",
  "name": "key"
},
v29 = {
  "kind": "ScalarField",
  "name": "name"
},
v30 = {
  "kind": "ScalarField",
  "name": "startValue"
},
v31 = {
  "kind": "ScalarField",
  "name": "confidence"
},
v32 = {
  "kind": "ScalarField",
  "name": "start"
},
v33 = {
  "kind": "ScalarField",
  "name": "end"
},
v34 = {
  "concreteType": "TownsquareTargetDateRange",
  "kind": "LinkedField",
  "name": "dateRange",
  "plural": false,
  "selections": [
    (v32/*: any*/),
    (v33/*: any*/)
  ]
},
v35 = {
  "concreteType": "TownsquareTargetDate",
  "kind": "LinkedField",
  "name": "date",
  "plural": false,
  "selections": [
    (v31/*: any*/),
    (v34/*: any*/)
  ]
},
v36 = [
  (v21/*: any*/),
  (v13/*: any*/)
],
v37 = {
  "kind": "ScalarField",
  "name": "variance"
},
v38 = {
  "concreteType": "TownsquareMetricTargetPeriodToMetricValueEdge",
  "kind": "LinkedField",
  "name": "latestValue",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareMetricValue",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": (v36/*: any*/)
    },
    (v37/*: any*/)
  ]
},
v39 = {
  "kind": "ScalarField",
  "name": "type"
},
v40 = {
  "kind": "ScalarField",
  "name": "subType"
},
v41 = {
  "kind": "Literal",
  "name": "first",
  "value": 100
},
v42 = [
  (v41/*: any*/),
  {
    "kind": "Literal",
    "name": "sort",
    "value": [
      "TIME_ASC"
    ]
  }
],
v43 = {
  "kind": "ScalarField",
  "name": "time"
},
v44 = {
  "kind": "ScalarField",
  "name": "picture"
},
v45 = {
  "kind": "ScalarField",
  "name": "creationDate"
},
v46 = [
  (v13/*: any*/)
],
v47 = {
  "kind": "ScalarField",
  "name": "score"
},
v48 = [
  (v21/*: any*/),
  (v47/*: any*/)
],
v49 = {
  "concreteType": "TownsquareGoalState",
  "kind": "LinkedField",
  "name": "newState",
  "plural": false,
  "selections": (v48/*: any*/)
},
v50 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
},
v51 = {
  "kind": "ScalarField",
  "name": "cursor"
},
v52 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "endCursor"
    },
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    }
  ]
},
v53 = {
  "args": (v42/*: any*/),
  "concreteType": "TownsquareMetricValueConnection",
  "kind": "LinkedField",
  "name": "values",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareMetricValueEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "TownsquareMetricValue",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v13/*: any*/),
            {
              "kind": "ScalarField",
              "name": "canDelete"
            },
            (v21/*: any*/),
            (v43/*: any*/),
            {
              "kind": "LinkedField",
              "name": "creator",
              "plural": false,
              "selections": [
                (v20/*: any*/),
                (v29/*: any*/),
                (v44/*: any*/),
                (v13/*: any*/)
              ]
            },
            {
              "kind": "LinkedField",
              "name": "origin",
              "plural": false,
              "selections": [
                (v20/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "concreteType": "TownsquareGoalUpdate",
                      "kind": "LinkedField",
                      "name": "goalUpdate",
                      "plural": false,
                      "selections": [
                        (v45/*: any*/),
                        {
                          "concreteType": "TownsquareGoal",
                          "kind": "LinkedField",
                          "name": "goal",
                          "plural": false,
                          "selections": (v46/*: any*/)
                        },
                        (v49/*: any*/),
                        (v13/*: any*/)
                      ]
                    }
                  ],
                  "type": "TownsquareFromGoalUpdate"
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v45/*: any*/)
                  ],
                  "type": "TownsquareFromMetricCreation"
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "updateDate"
                    }
                  ],
                  "type": "TownsquareFromMetricUpdate"
                }
              ]
            },
            (v50/*: any*/),
            (v20/*: any*/)
          ]
        },
        (v51/*: any*/)
      ]
    },
    (v52/*: any*/),
    (v50/*: any*/)
  ],
  "storageKey": "values(first:100,sort:[\"TIME_ASC\"])"
},
v54 = {
  "args": (v42/*: any*/),
  "filters": [
    "sort"
  ],
  "handle": "connection",
  "key": "SuccessMeasureChart_values",
  "kind": "LinkedHandle",
  "name": "values"
},
v55 = {
  "kind": "ScalarField",
  "name": "targetValue"
},
v56 = {
  "concreteType": "TownsquareMetricValue",
  "kind": "LinkedField",
  "name": "snapshotValue",
  "plural": false,
  "selections": (v36/*: any*/)
},
v57 = [
  (v43/*: any*/),
  (v13/*: any*/)
],
v58 = {
  "args": (v42/*: any*/),
  "concreteType": "TownsquareMetricTargetToMetricValueConnection",
  "kind": "LinkedField",
  "name": "metricValues",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareMetricTargetToMetricValueEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "TownsquareMetricValue",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": (v57/*: any*/)
        },
        {
          "concreteType": "TownsquareMetricTargetPeriod",
          "kind": "LinkedField",
          "name": "metricTargetPeriod",
          "plural": false,
          "selections": [
            {
              "concreteType": "TownsquareTargetDate",
              "kind": "LinkedField",
              "name": "date",
              "plural": false,
              "selections": [
                {
                  "concreteType": "TownsquareTargetDateRange",
                  "kind": "LinkedField",
                  "name": "dateRange",
                  "plural": false,
                  "selections": [
                    (v33/*: any*/)
                  ]
                }
              ]
            },
            (v21/*: any*/)
          ]
        },
        (v37/*: any*/)
      ]
    }
  ],
  "storageKey": "metricValues(first:100,sort:[\"TIME_ASC\"])"
},
v59 = {
  "kind": "ScalarField",
  "name": "url"
},
v60 = {
  "concreteType": "TownsquareStatus",
  "kind": "LinkedField",
  "name": "status",
  "plural": false,
  "selections": (v48/*: any*/)
},
v61 = {
  "kind": "ScalarField",
  "name": "scoringMode"
},
v62 = {
  "concreteType": "TownsquareTargetDate",
  "kind": "LinkedField",
  "name": "targetDate",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareTargetDateRange",
      "kind": "LinkedField",
      "name": "dateRange",
      "plural": false,
      "selections": [
        (v33/*: any*/),
        (v32/*: any*/)
      ]
    }
  ]
},
v63 = {
  "kind": "ScalarField",
  "name": "accessLevel"
},
v64 = {
  "kind": "ScalarField",
  "name": "startDate"
},
v65 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v66 = {
  "kind": "ScalarField",
  "name": "editDate"
},
v67 = {
  "concreteType": "TownsquareCommentConnection",
  "kind": "LinkedField",
  "name": "comments",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareCommentEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "TownsquareComment",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v13/*: any*/),
            {
              "kind": "LinkedField",
              "name": "creator",
              "plural": false,
              "selections": [
                (v20/*: any*/),
                (v29/*: any*/),
                (v13/*: any*/),
                (v65/*: any*/),
                (v44/*: any*/)
              ]
            },
            {
              "kind": "ScalarField",
              "name": "commentText"
            },
            (v66/*: any*/),
            (v45/*: any*/)
          ]
        }
      ]
    },
    (v50/*: any*/)
  ]
},
v68 = {
  "kind": "ScalarField",
  "name": "uuid"
},
v69 = {
  "kind": "ScalarField",
  "name": "externalEntityId"
},
v70 = {
  "concreteType": "TownsquareGoalProgress",
  "kind": "LinkedField",
  "name": "progress",
  "plural": false,
  "selections": [
    (v39/*: any*/)
  ]
},
v71 = {
  "kind": "ScalarField",
  "name": "percentage"
},
v72 = {
  "concreteType": "TownsquareGoalProgress",
  "kind": "LinkedField",
  "name": "progress",
  "plural": false,
  "selections": [
    (v71/*: any*/)
  ]
},
v73 = {
  "concreteType": "TownsquareGoalProgress",
  "kind": "LinkedField",
  "name": "progress",
  "plural": false,
  "selections": [
    (v71/*: any*/),
    (v39/*: any*/)
  ]
},
v74 = {
  "kind": "ScalarField",
  "name": "source"
},
v75 = {
  "concreteType": "TownsquareMetricValue",
  "kind": "LinkedField",
  "name": "latestValue",
  "plural": false,
  "selections": (v57/*: any*/)
},
v76 = {
  "kind": "ScalarField",
  "name": "label"
},
v77 = {
  "kind": "ScalarField",
  "name": "summary"
},
v78 = [
  (v20/*: any*/),
  (v65/*: any*/),
  (v29/*: any*/),
  (v44/*: any*/),
  (v13/*: any*/)
],
v79 = {
  "kind": "LinkedField",
  "name": "creator",
  "plural": false,
  "selections": (v78/*: any*/)
},
v80 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isTownsquareHighlight"
},
v81 = [
  (v20/*: any*/),
  (v44/*: any*/),
  (v29/*: any*/),
  (v65/*: any*/),
  (v13/*: any*/)
],
v82 = {
  "kind": "LinkedField",
  "name": "creator",
  "plural": false,
  "selections": (v81/*: any*/)
},
v83 = {
  "kind": "LinkedField",
  "name": "lastEditedBy",
  "plural": false,
  "selections": (v81/*: any*/)
},
v84 = {
  "kind": "ScalarField",
  "name": "lastEditedDate"
},
v85 = [
  (v45/*: any*/),
  {
    "concreteType": "TownsquareGoalState",
    "kind": "LinkedField",
    "name": "newState",
    "plural": false,
    "selections": [
      (v21/*: any*/),
      (v47/*: any*/),
      (v76/*: any*/)
    ]
  },
  (v77/*: any*/),
  (v79/*: any*/),
  {
    "concreteType": "TownsquareUpdateNoteConnection",
    "kind": "LinkedField",
    "name": "updateNotes",
    "plural": false,
    "selections": [
      {
        "concreteType": "TownsquareUpdateNoteEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "concreteType": "TownsquareUpdateNote",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v13/*: any*/),
              (v77/*: any*/),
              (v14/*: any*/),
              (v27/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  {
    "concreteType": "TownsquareHighlightConnection",
    "kind": "LinkedField",
    "name": "highlights",
    "plural": false,
    "selections": [
      {
        "concreteType": "TownsquareHighlightEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v20/*: any*/),
              (v13/*: any*/),
              (v77/*: any*/),
              (v14/*: any*/),
              (v80/*: any*/),
              (v82/*: any*/),
              (v83/*: any*/),
              (v45/*: any*/),
              (v84/*: any*/)
            ]
          }
        ]
      },
      (v50/*: any*/)
    ]
  },
  (v13/*: any*/)
],
v86 = {
  "concreteType": "TownsquareGoalUpdate",
  "kind": "LinkedField",
  "name": "latestUserUpdate",
  "plural": false,
  "selections": (v85/*: any*/)
},
v87 = {
  "kind": "ScalarField",
  "name": "isArchived"
},
v88 = {
  "concreteType": "TownsquareGoalTypeIcon",
  "kind": "LinkedField",
  "name": "icon",
  "plural": false,
  "selections": [
    (v28/*: any*/)
  ]
},
v89 = {
  "concreteType": "TownsquareGoalType",
  "kind": "LinkedField",
  "name": "goalType",
  "plural": false,
  "selections": [
    (v24/*: any*/),
    (v25/*: any*/),
    (v88/*: any*/),
    (v13/*: any*/)
  ]
},
v90 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  }
],
v91 = {
  "kind": "ScalarField",
  "name": "missedUpdate"
},
v92 = {
  "kind": "ScalarField",
  "name": "updateType"
},
v93 = [
  {
    "concreteType": "TownsquareGoalUpdateEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "concreteType": "TownsquareGoalUpdate",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v91/*: any*/),
          (v92/*: any*/),
          (v77/*: any*/),
          (v66/*: any*/),
          (v45/*: any*/),
          (v13/*: any*/)
        ]
      }
    ]
  }
],
v94 = {
  "args": (v90/*: any*/),
  "concreteType": "TownsquareGoalUpdateConnection",
  "kind": "LinkedField",
  "name": "updates",
  "plural": false,
  "selections": (v93/*: any*/),
  "storageKey": "updates(first:10)"
},
v95 = {
  "concreteType": "TownsquareMetricTargetConnection",
  "kind": "LinkedField",
  "name": "metricTargets",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareMetricTargetEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "TownsquareMetricTarget",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v13/*: any*/),
            {
              "concreteType": "TownsquareMetric",
              "kind": "LinkedField",
              "name": "metric",
              "plural": false,
              "selections": [
                (v13/*: any*/),
                (v29/*: any*/),
                (v39/*: any*/),
                (v40/*: any*/),
                (v27/*: any*/),
                (v69/*: any*/),
                (v74/*: any*/),
                (v75/*: any*/)
              ]
            },
            (v56/*: any*/),
            (v30/*: any*/),
            (v55/*: any*/)
          ]
        }
      ]
    }
  ]
},
v96 = [
  (v34/*: any*/)
],
v97 = {
  "concreteType": "TownsquareTargetDate",
  "kind": "LinkedField",
  "name": "targetDate",
  "plural": false,
  "selections": (v96/*: any*/)
},
v98 = {
  "kind": "LinkedField",
  "name": "owner",
  "plural": false,
  "selections": (v78/*: any*/)
},
v99 = {
  "concreteType": "TownsquareGoalConnection",
  "kind": "LinkedField",
  "name": "subGoals",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareGoalEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "TownsquareGoal",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v13/*: any*/),
            (v29/*: any*/),
            (v27/*: any*/),
            (v73/*: any*/),
            {
              "concreteType": "TownsquareGoalType",
              "kind": "LinkedField",
              "name": "goalType",
              "plural": false,
              "selections": [
                (v19/*: any*/),
                (v13/*: any*/),
                (v88/*: any*/)
              ]
            },
            (v95/*: any*/),
            (v59/*: any*/),
            (v61/*: any*/),
            (v97/*: any*/),
            (v98/*: any*/),
            (v86/*: any*/),
            (v87/*: any*/),
            (v60/*: any*/),
            {
              "args": [
                {
                  "kind": "Literal",
                  "name": "first",
                  "value": 30
                }
              ],
              "concreteType": "TownsquareGoalUpdateConnection",
              "kind": "LinkedField",
              "name": "updates",
              "plural": false,
              "selections": (v93/*: any*/),
              "storageKey": "updates(first:30)"
            }
          ]
        }
      ]
    }
  ]
},
v100 = {
  "concreteType": "TownsquareUserConnection",
  "kind": "LinkedField",
  "name": "watchers",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "count"
    }
  ]
},
v101 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 20
  }
],
v102 = [
  (v21/*: any*/),
  (v43/*: any*/),
  (v13/*: any*/)
],
v103 = [
  (v76/*: any*/),
  (v34/*: any*/)
],
v104 = [
  (v39/*: any*/),
  (v71/*: any*/)
],
v105 = {
  "kind": "ScalarField",
  "name": "canEditUpdates"
},
v106 = {
  "kind": "ScalarField",
  "name": "canDeleteUpdates"
},
v107 = {
  "kind": "InlineFragment",
  "selections": (v46/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v108 = {
  "kind": "Literal",
  "name": "first",
  "value": 200
},
v109 = [
  (v108/*: any*/),
  (v11/*: any*/)
],
v110 = [
  {
    "kind": "InlineFragment",
    "selections": [
      (v77/*: any*/),
      (v14/*: any*/),
      (v82/*: any*/),
      (v83/*: any*/),
      (v45/*: any*/),
      (v84/*: any*/)
    ],
    "type": "TownsquareHighlight",
    "abstractKey": "__isTownsquareHighlight"
  }
],
v111 = {
  "concreteType": "TownsquareGoalCapabilities",
  "kind": "LinkedField",
  "name": "capabilities",
  "plural": false,
  "selections": [
    (v106/*: any*/),
    (v105/*: any*/)
  ]
},
v112 = {
  "kind": "ScalarField",
  "name": "canAddLinkedProjects"
},
v113 = [
  (v108/*: any*/),
  {
    "kind": "Literal",
    "name": "tql",
    "value": "archived = false"
  }
],
v114 = {
  "concreteType": "TownsquareProjectState",
  "kind": "LinkedField",
  "name": "state",
  "plural": false,
  "selections": (v22/*: any*/)
},
v115 = {
  "kind": "LinkedField",
  "name": "owner",
  "plural": false,
  "selections": [
    (v20/*: any*/),
    (v13/*: any*/),
    (v29/*: any*/),
    (v44/*: any*/),
    (v65/*: any*/)
  ]
},
v116 = [
  (v20/*: any*/),
  (v13/*: any*/)
],
v117 = {
  "concreteType": "TownsquareContributorConnection",
  "kind": "LinkedField",
  "name": "contributors",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareContributorEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "TownsquareContributor",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "name": "userContributor",
              "plural": false,
              "selections": (v116/*: any*/)
            },
            {
              "concreteType": "TownsquareTeamContributor",
              "kind": "LinkedField",
              "name": "teamContributor",
              "plural": false,
              "selections": [
                {
                  "concreteType": "TownsquareUserConnection",
                  "kind": "LinkedField",
                  "name": "contributingMembers",
                  "plural": false,
                  "selections": [
                    {
                      "concreteType": "TownsquareUserEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": (v116/*: any*/)
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
},
v118 = {
  "concreteType": "TownsquareIconURIs",
  "kind": "LinkedField",
  "name": "iconUrl",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareThemeURIs",
      "kind": "LinkedField",
      "name": "roundedSquare",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "dark"
        },
        {
          "kind": "ScalarField",
          "name": "light"
        }
      ]
    }
  ]
},
v119 = {
  "concreteType": "TownsquareTargetDate",
  "kind": "LinkedField",
  "name": "dueDate",
  "plural": false,
  "selections": (v96/*: any*/)
},
v120 = {
  "args": (v113/*: any*/),
  "filters": [
    "tql"
  ],
  "handle": "connection",
  "key": "GoalContentProjects_projects",
  "kind": "LinkedHandle",
  "name": "projects"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/)
    ],
    "kind": "Fragment",
    "name": "AggGoalTabContentQuery",
    "selections": [
      {
        "args": (v10/*: any*/),
        "concreteType": "TownsquareGoal",
        "kind": "LinkedField",
        "name": "goals_byKey",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "GoalContentAbout"
          },
          {
            "condition": "isUpdatesTab",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "AggGoalUpdatesTabContent"
              }
            ]
          },
          {
            "condition": "isJiraAlignTab",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": (v12/*: any*/),
                "kind": "FragmentSpread",
                "name": "GoalContentJiraAlign"
              }
            ]
          },
          {
            "condition": "isJiraTab",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": (v12/*: any*/),
                "kind": "FragmentSpread",
                "name": "GoalContentJira"
              }
            ]
          },
          {
            "condition": "isLearningsTab",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "GoalContentLearnings"
              }
            ]
          },
          {
            "condition": "isRisksTab",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "GoalContentRisks"
              }
            ]
          },
          {
            "condition": "isDecisionsTab",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "GoalContentDecisions"
              }
            ]
          },
          {
            "condition": "isProjectsTab",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "GoalContentProjects"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v8/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v6/*: any*/),
      (v5/*: any*/),
      (v7/*: any*/),
      (v2/*: any*/),
      (v9/*: any*/)
    ],
    "kind": "Operation",
    "name": "AggGoalTabContentQuery",
    "selections": [
      {
        "args": (v10/*: any*/),
        "concreteType": "TownsquareGoal",
        "kind": "LinkedField",
        "name": "goals_byKey",
        "plural": false,
        "selections": [
          (v13/*: any*/),
          (v14/*: any*/),
          {
            "kind": "ScalarField",
            "name": "descriptionWhy"
          },
          {
            "kind": "ScalarField",
            "name": "descriptionMeasurement"
          },
          {
            "kind": "ScalarField",
            "name": "canPostUpdate"
          },
          {
            "concreteType": "TownsquareGoalCapabilities",
            "kind": "LinkedField",
            "name": "capabilities",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "canEditMetadata"
              },
              {
                "kind": "ScalarField",
                "name": "canCommentOnGoal"
              },
              (v15/*: any*/),
              {
                "concreteType": "TownsquareGoalAppCapabilities",
                "kind": "LinkedField",
                "name": "apps",
                "plural": false,
                "selections": [
                  (v16/*: any*/),
                  (v17/*: any*/)
                ]
              },
              (v18/*: any*/),
              {
                "kind": "ScalarField",
                "name": "canAddLinkedGoals"
              }
            ]
          },
          {
            "concreteType": "TownsquareGoalType",
            "kind": "LinkedField",
            "name": "goalType",
            "plural": false,
            "selections": [
              (v19/*: any*/),
              {
                "concreteType": "TownsquareGoalType",
                "kind": "LinkedField",
                "name": "successMeasure",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "state"
                  },
                  (v13/*: any*/),
                  (v24/*: any*/),
                  (v25/*: any*/)
                ]
              },
              (v13/*: any*/),
              (v24/*: any*/)
            ]
          },
          {
            "args": (v26/*: any*/),
            "concreteType": "TownsquareGoalConnection",
            "kind": "LinkedField",
            "name": "successMeasures",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareGoalEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareGoal",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v27/*: any*/),
                      (v13/*: any*/),
                      {
                        "concreteType": "TownsquareGoalIcon",
                        "kind": "LinkedField",
                        "name": "icon",
                        "plural": false,
                        "selections": [
                          (v28/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "appearance"
                          }
                        ]
                      },
                      (v29/*: any*/),
                      {
                        "concreteType": "TownsquareMetricTargetConnection",
                        "kind": "LinkedField",
                        "name": "metricTargets",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareMetricTargetEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "TownsquareMetricTarget",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v30/*: any*/),
                                  {
                                    "concreteType": "TownsquareMetricTargetPeriodConnection",
                                    "kind": "LinkedField",
                                    "name": "metricTargetPeriods",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "TownsquareMetricTargetPeriodEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "concreteType": "TownsquareMetricTargetPeriod",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v35/*: any*/),
                                              (v21/*: any*/),
                                              (v38/*: any*/)
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  (v13/*: any*/),
                                  {
                                    "concreteType": "TownsquareMetric",
                                    "kind": "LinkedField",
                                    "name": "metric",
                                    "plural": false,
                                    "selections": [
                                      (v39/*: any*/),
                                      (v40/*: any*/),
                                      (v29/*: any*/),
                                      (v13/*: any*/),
                                      (v53/*: any*/),
                                      (v54/*: any*/)
                                    ]
                                  },
                                  (v55/*: any*/),
                                  (v56/*: any*/),
                                  (v58/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      (v28/*: any*/),
                      (v59/*: any*/),
                      (v60/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "owner",
                        "plural": false,
                        "selections": [
                          (v20/*: any*/),
                          (v44/*: any*/),
                          (v29/*: any*/),
                          (v13/*: any*/)
                        ]
                      },
                      (v61/*: any*/),
                      (v62/*: any*/),
                      {
                        "concreteType": "TownsquareGoalCapabilities",
                        "kind": "LinkedField",
                        "name": "capabilities",
                        "plural": false,
                        "selections": [
                          (v18/*: any*/),
                          (v15/*: any*/),
                          {
                            "concreteType": "TownsquareGoalAppCapabilities",
                            "kind": "LinkedField",
                            "name": "apps",
                            "plural": false,
                            "selections": [
                              (v16/*: any*/)
                            ]
                          }
                        ]
                      },
                      (v63/*: any*/),
                      (v64/*: any*/)
                    ]
                  },
                  (v20/*: any*/)
                ]
              }
            ],
            "storageKey": "successMeasures(first:50)"
          },
          (v67/*: any*/),
          {
            "concreteType": "TownsquareGoal",
            "kind": "LinkedField",
            "name": "parentGoal",
            "plural": false,
            "selections": [
              (v68/*: any*/),
              (v13/*: any*/)
            ]
          },
          {
            "concreteType": "TownsquareMetricTargetConnection",
            "kind": "LinkedField",
            "name": "metricTargets",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareMetricTargetEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareMetricTarget",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v20/*: any*/),
                      (v13/*: any*/),
                      {
                        "concreteType": "TownsquareMetric",
                        "kind": "LinkedField",
                        "name": "metric",
                        "plural": false,
                        "selections": [
                          (v13/*: any*/),
                          (v29/*: any*/),
                          (v39/*: any*/),
                          (v40/*: any*/),
                          (v27/*: any*/),
                          (v69/*: any*/),
                          (v50/*: any*/),
                          (v53/*: any*/),
                          (v54/*: any*/)
                        ]
                      },
                      (v56/*: any*/),
                      (v30/*: any*/),
                      (v55/*: any*/),
                      {
                        "concreteType": "TownsquareMetricTargetPeriodConnection",
                        "kind": "LinkedField",
                        "name": "metricTargetPeriods",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareMetricTargetPeriodEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "TownsquareMetricTargetPeriod",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v35/*: any*/),
                                  (v21/*: any*/),
                                  (v38/*: any*/),
                                  (v20/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      (v58/*: any*/)
                    ]
                  }
                ]
              },
              (v50/*: any*/)
            ]
          },
          (v63/*: any*/),
          (v64/*: any*/),
          (v62/*: any*/),
          {
            "concreteType": "TownsquareStatus",
            "kind": "LinkedField",
            "name": "status",
            "plural": false,
            "selections": (v22/*: any*/)
          },
          (v27/*: any*/),
          (v70/*: any*/),
          {
            "condition": "isUpdatesTab",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "concreteType": "TownsquareStatus",
                "kind": "LinkedField",
                "name": "status",
                "plural": false,
                "selections": [
                  (v47/*: any*/)
                ]
              },
              {
                "kind": "ScalarField",
                "name": "latestUpdateDate"
              },
              (v61/*: any*/),
              (v72/*: any*/),
              {
                "args": (v26/*: any*/),
                "concreteType": "TownsquareGoalConnection",
                "kind": "LinkedField",
                "name": "successMeasures",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TownsquareGoalEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "TownsquareGoal",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v73/*: any*/),
                          {
                            "concreteType": "TownsquareMetricTargetConnection",
                            "kind": "LinkedField",
                            "name": "metricTargets",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareMetricTargetEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareMetricTarget",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "TownsquareMetric",
                                        "kind": "LinkedField",
                                        "name": "metric",
                                        "plural": false,
                                        "selections": [
                                          (v27/*: any*/),
                                          (v69/*: any*/),
                                          (v74/*: any*/),
                                          (v75/*: any*/)
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "name": "owner",
                            "plural": false,
                            "selections": [
                              (v65/*: any*/)
                            ]
                          },
                          (v86/*: any*/),
                          (v68/*: any*/),
                          (v87/*: any*/),
                          (v89/*: any*/),
                          (v94/*: any*/)
                        ]
                      }
                    ]
                  }
                ],
                "storageKey": "successMeasures(first:50)"
              },
              (v99/*: any*/),
              {
                "concreteType": "TownsquareTargetDate",
                "kind": "LinkedField",
                "name": "targetDate",
                "plural": false,
                "selections": [
                  (v31/*: any*/)
                ]
              },
              (v100/*: any*/),
              {
                "args": (v101/*: any*/),
                "concreteType": "TownsquareGoalUpdateConnection",
                "kind": "LinkedField",
                "name": "updates",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TownsquareGoalUpdateEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "TownsquareGoalUpdate",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v13/*: any*/),
                          (v77/*: any*/),
                          {
                            "concreteType": "TownsquareUpdateNoteConnection",
                            "kind": "LinkedField",
                            "name": "updateNotes",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareUpdateNoteEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareUpdateNote",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v77/*: any*/),
                                      (v14/*: any*/),
                                      (v13/*: any*/),
                                      (v27/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          (v20/*: any*/),
                          (v68/*: any*/),
                          (v45/*: any*/),
                          (v91/*: any*/),
                          (v92/*: any*/),
                          (v49/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "newTargetDate"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "newTargetDateConfidence"
                          },
                          {
                            "concreteType": "TownsquareHighlightConnection",
                            "kind": "LinkedField",
                            "name": "highlights",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareHighlightEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v77/*: any*/),
                                      (v14/*: any*/),
                                      (v20/*: any*/),
                                      (v13/*: any*/),
                                      (v80/*: any*/),
                                      (v82/*: any*/),
                                      (v83/*: any*/),
                                      (v45/*: any*/),
                                      (v84/*: any*/)
                                    ]
                                  }
                                ]
                              },
                              (v50/*: any*/)
                            ]
                          },
                          {
                            "concreteType": "TownsquareGoalMetricUpdateConnection",
                            "kind": "LinkedField",
                            "name": "metricUpdate",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareGoalMetricUpdateEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareGoalMetricUpdate",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "TownsquareMetric",
                                        "kind": "LinkedField",
                                        "name": "metric",
                                        "plural": false,
                                        "selections": [
                                          (v13/*: any*/),
                                          (v29/*: any*/),
                                          (v39/*: any*/),
                                          (v40/*: any*/),
                                          (v27/*: any*/),
                                          (v74/*: any*/),
                                          (v75/*: any*/),
                                          {
                                            "args": [
                                              (v41/*: any*/),
                                              {
                                                "kind": "Literal",
                                                "name": "sort",
                                                "value": [
                                                  "TIME_DESC"
                                                ]
                                              }
                                            ],
                                            "concreteType": "TownsquareMetricValueConnection",
                                            "kind": "LinkedField",
                                            "name": "values",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "concreteType": "TownsquareMetricValueEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "concreteType": "TownsquareMetricValue",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": (v102/*: any*/)
                                                  }
                                                ]
                                              }
                                            ],
                                            "storageKey": "values(first:100,sort:[\"TIME_DESC\"])"
                                          }
                                        ]
                                      },
                                      {
                                        "concreteType": "TownsquareMetricValue",
                                        "kind": "LinkedField",
                                        "name": "newValue",
                                        "plural": false,
                                        "selections": (v102/*: any*/)
                                      },
                                      {
                                        "concreteType": "TownsquareMetricValue",
                                        "kind": "LinkedField",
                                        "name": "oldValue",
                                        "plural": false,
                                        "selections": [
                                          (v43/*: any*/),
                                          (v13/*: any*/),
                                          (v21/*: any*/)
                                        ]
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "newStartValue"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "newTargetValue"
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "concreteType": "TownsquareGoal",
                            "kind": "LinkedField",
                            "name": "goal",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareMetricTargetConnection",
                                "kind": "LinkedField",
                                "name": "metricTargets",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareMetricTargetEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "TownsquareMetricTarget",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "TownsquareMetric",
                                            "kind": "LinkedField",
                                            "name": "metric",
                                            "plural": false,
                                            "selections": [
                                              (v13/*: any*/),
                                              (v27/*: any*/)
                                            ]
                                          },
                                          {
                                            "concreteType": "TownsquareMetricTargetPeriodConnection",
                                            "kind": "LinkedField",
                                            "name": "metricTargetPeriods",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "concreteType": "TownsquareMetricTargetPeriodEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "concreteType": "TownsquareMetricTargetPeriod",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "concreteType": "TownsquareTargetDate",
                                                        "kind": "LinkedField",
                                                        "name": "date",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "concreteType": "TownsquareTargetDateRange",
                                                            "kind": "LinkedField",
                                                            "name": "dateRange",
                                                            "plural": false,
                                                            "selections": [
                                                              (v32/*: any*/)
                                                            ]
                                                          }
                                                        ]
                                                      },
                                                      (v21/*: any*/)
                                                    ]
                                                  }
                                                ]
                                              }
                                            ]
                                          },
                                          (v13/*: any*/),
                                          (v30/*: any*/),
                                          (v55/*: any*/)
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              },
                              (v13/*: any*/),
                              (v61/*: any*/),
                              (v27/*: any*/),
                              {
                                "concreteType": "TownsquareGoalType",
                                "kind": "LinkedField",
                                "name": "goalType",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareGoalType",
                                    "kind": "LinkedField",
                                    "name": "successMeasure",
                                    "plural": false,
                                    "selections": [
                                      (v24/*: any*/),
                                      (v25/*: any*/),
                                      (v13/*: any*/)
                                    ]
                                  },
                                  (v13/*: any*/)
                                ]
                              },
                              (v70/*: any*/),
                              {
                                "args": (v26/*: any*/),
                                "concreteType": "TownsquareGoalConnection",
                                "kind": "LinkedField",
                                "name": "successMeasures",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareGoalEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "TownsquareGoal",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v13/*: any*/),
                                          (v29/*: any*/),
                                          (v27/*: any*/),
                                          (v73/*: any*/),
                                          (v95/*: any*/),
                                          (v59/*: any*/),
                                          (v61/*: any*/),
                                          (v97/*: any*/),
                                          (v98/*: any*/),
                                          (v86/*: any*/),
                                          (v68/*: any*/),
                                          (v87/*: any*/),
                                          (v89/*: any*/),
                                          (v60/*: any*/),
                                          (v94/*: any*/)
                                        ]
                                      },
                                      (v20/*: any*/)
                                    ]
                                  }
                                ],
                                "storageKey": "successMeasures(first:50)"
                              },
                              (v99/*: any*/),
                              {
                                "args": (v90/*: any*/),
                                "concreteType": "TownsquareGoalUpdateConnection",
                                "kind": "LinkedField",
                                "name": "updates",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareGoalUpdateEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "TownsquareGoalUpdate",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v13/*: any*/),
                                          (v77/*: any*/),
                                          {
                                            "concreteType": "TownsquareUpdateNoteConnection",
                                            "kind": "LinkedField",
                                            "name": "updateNotes",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "concreteType": "TownsquareUpdateNoteEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "concreteType": "TownsquareUpdateNote",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                      (v77/*: any*/),
                                                      (v14/*: any*/),
                                                      (v13/*: any*/)
                                                    ]
                                                  }
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ],
                                "storageKey": "updates(first:10)"
                              }
                            ]
                          },
                          (v79/*: any*/),
                          {
                            "concreteType": "TownsquareTargetDate",
                            "kind": "LinkedField",
                            "name": "newDueDate",
                            "plural": false,
                            "selections": (v103/*: any*/)
                          },
                          {
                            "concreteType": "TownsquareGoalProgress",
                            "kind": "LinkedField",
                            "name": "newProgress",
                            "plural": false,
                            "selections": (v104/*: any*/)
                          },
                          {
                            "kind": "LinkedField",
                            "name": "lastEditedBy",
                            "plural": false,
                            "selections": [
                              (v20/*: any*/),
                              (v65/*: any*/),
                              (v29/*: any*/),
                              (v13/*: any*/)
                            ]
                          },
                          (v66/*: any*/),
                          {
                            "concreteType": "GraphStoreSimplifiedUserViewedGoalUpdateInverseConnection",
                            "kind": "LinkedField",
                            "name": "viewers",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "GraphStoreSimplifiedUserViewedGoalUpdateInverseEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v20/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v13/*: any*/),
                                          (v29/*: any*/),
                                          (v65/*: any*/),
                                          (v44/*: any*/)
                                        ],
                                        "type": "AtlassianAccountUser"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v46/*: any*/),
                                        "type": "AppUser"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v46/*: any*/),
                                        "type": "CustomerUser"
                                      }
                                    ]
                                  },
                                  (v13/*: any*/)
                                ]
                              }
                            ]
                          },
                          (v59/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "ari"
                          },
                          (v67/*: any*/),
                          {
                            "concreteType": "TownsquareGoalState",
                            "kind": "LinkedField",
                            "name": "oldState",
                            "plural": false,
                            "selections": (v48/*: any*/)
                          },
                          {
                            "concreteType": "TownsquareTargetDate",
                            "kind": "LinkedField",
                            "name": "oldDueDate",
                            "plural": false,
                            "selections": (v103/*: any*/)
                          },
                          {
                            "args": (v26/*: any*/),
                            "concreteType": "TownsquareGoalBundledUpdateConnection",
                            "kind": "LinkedField",
                            "name": "bundledUpdates",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareGoalBundledUpdateEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareGoalUpdate",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": (v85/*: any*/)
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "nodeMissingReason"
                                  },
                                  {
                                    "concreteType": "TownsquareGoal",
                                    "kind": "LinkedField",
                                    "name": "goal",
                                    "plural": false,
                                    "selections": [
                                      (v13/*: any*/),
                                      (v29/*: any*/),
                                      {
                                        "concreteType": "TownsquareGoalProgress",
                                        "kind": "LinkedField",
                                        "name": "progress",
                                        "plural": false,
                                        "selections": (v104/*: any*/)
                                      },
                                      (v95/*: any*/),
                                      (v59/*: any*/),
                                      (v61/*: any*/),
                                      (v97/*: any*/),
                                      (v98/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ],
                            "storageKey": "bundledUpdates(first:50)"
                          }
                        ]
                      },
                      (v51/*: any*/),
                      (v20/*: any*/)
                    ]
                  },
                  (v52/*: any*/),
                  (v50/*: any*/)
                ],
                "storageKey": "updates(first:20)"
              },
              {
                "args": (v101/*: any*/),
                "handle": "connection",
                "key": "UpdatesList__updates",
                "kind": "LinkedHandle",
                "name": "updates"
              },
              {
                "concreteType": "TownsquareMetricTargetConnection",
                "kind": "LinkedField",
                "name": "metricTargets",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TownsquareMetricTargetEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "TownsquareMetricTarget",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareMetric",
                            "kind": "LinkedField",
                            "name": "metric",
                            "plural": false,
                            "selections": [
                              (v74/*: any*/),
                              {
                                "concreteType": "TownsquareMetricValue",
                                "kind": "LinkedField",
                                "name": "latestValue",
                                "plural": false,
                                "selections": [
                                  (v43/*: any*/),
                                  (v21/*: any*/),
                                  (v13/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "concreteType": "TownsquareGoalUpdate",
                "kind": "LinkedField",
                "name": "latestUserUpdate",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TownsquareGoalMetricUpdateConnection",
                    "kind": "LinkedField",
                    "name": "metricUpdate",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "TownsquareGoalMetricUpdateEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "TownsquareGoalMetricUpdate",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareMetricValue",
                                "kind": "LinkedField",
                                "name": "newValue",
                                "plural": false,
                                "selections": (v57/*: any*/)
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  (v13/*: any*/)
                ]
              },
              {
                "concreteType": "TownsquareGoalCapabilities",
                "kind": "LinkedField",
                "name": "capabilities",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "canWatchGoal"
                  },
                  (v105/*: any*/),
                  (v106/*: any*/)
                ]
              },
              {
                "kind": "ScalarField",
                "name": "isWatching"
              },
              (v28/*: any*/),
              (v87/*: any*/),
              {
                "kind": "ScalarField",
                "name": "canEditUpdate"
              },
              {
                "concreteType": "TownsquareGoalCapabilities",
                "kind": "LinkedField",
                "name": "capabilities",
                "plural": false,
                "selections": [
                  (v18/*: any*/)
                ]
              },
              {
                "kind": "ScalarField",
                "name": "updateStreak"
              }
            ]
          },
          {
            "condition": "isJiraAlignTab",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": (v12/*: any*/),
                "concreteType": "GraphStoreSimplifiedAtlasGoalHasJiraAlignProjectConnection",
                "kind": "LinkedField",
                "name": "jiraAlignItems",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "GraphStoreSimplifiedAtlasGoalHasJiraAlignProjectEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v20/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v13/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "mercuryProjectName"
                              },
                              {
                                "kind": "LinkedField",
                                "name": "mercuryProjectStatus",
                                "plural": false,
                                "selections": [
                                  (v20/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "mercuryName"
                                  },
                                  (v107/*: any*/)
                                ]
                              },
                              {
                                "kind": "ScalarField",
                                "name": "mercuryTargetDateEnd"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "mercuryProjectUrl"
                              },
                              {
                                "kind": "LinkedField",
                                "name": "mercuryProjectOwner",
                                "plural": false,
                                "selections": (v78/*: any*/)
                              },
                              {
                                "kind": "LinkedField",
                                "name": "externalOwner",
                                "plural": false,
                                "selections": [
                                  (v20/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "firstName"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "lastName"
                                  }
                                ]
                              }
                            ],
                            "type": "JiraAlignAggProject"
                          },
                          (v107/*: any*/)
                        ]
                      },
                      (v13/*: any*/)
                    ]
                  },
                  (v50/*: any*/)
                ]
              },
              {
                "concreteType": "TownsquareGoalCapabilities",
                "kind": "LinkedField",
                "name": "capabilities",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "canAddJiraAlignItems"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "canRemoveJiraAlignItems"
                  }
                ]
              }
            ]
          },
          {
            "condition": "isJiraTab",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "concreteType": "TownsquareGoalCapabilities",
                "kind": "LinkedField",
                "name": "capabilities",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "canAddLinkedWorkItems"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "canRemoveLinkedWorkItems"
                  }
                ]
              },
              {
                "args": (v109/*: any*/),
                "concreteType": "GraphStoreSimplifiedJiraEpicContributesToAtlasGoalInverseConnection",
                "kind": "LinkedField",
                "name": "workItems",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "GraphStoreSimplifiedJiraEpicContributesToAtlasGoalInverseEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v20/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v13/*: any*/),
                              (v28/*: any*/),
                              (v77/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "webUrl"
                              }
                            ],
                            "type": "JiraIssue"
                          },
                          (v107/*: any*/)
                        ]
                      },
                      (v51/*: any*/),
                      (v13/*: any*/)
                    ]
                  },
                  (v52/*: any*/),
                  (v50/*: any*/)
                ]
              },
              {
                "args": (v109/*: any*/),
                "filters": [
                  "queryContext"
                ],
                "handle": "connection",
                "key": "GoalContentJira_workItems",
                "kind": "LinkedHandle",
                "name": "workItems"
              }
            ]
          },
          {
            "condition": "isLearningsTab",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              (v28/*: any*/),
              (v59/*: any*/),
              (v100/*: any*/),
              {
                "concreteType": "TownsquareHighlightConnection",
                "kind": "LinkedField",
                "name": "highlights",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TownsquareHighlightEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v20/*: any*/),
                          (v13/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": (v110/*: any*/),
                            "type": "TownsquareLearning"
                          }
                        ]
                      }
                    ]
                  },
                  (v50/*: any*/)
                ]
              },
              (v111/*: any*/)
            ]
          },
          {
            "condition": "isRisksTab",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              (v28/*: any*/),
              (v59/*: any*/),
              (v100/*: any*/),
              {
                "concreteType": "TownsquareHighlightConnection",
                "kind": "LinkedField",
                "name": "highlights",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TownsquareHighlightEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v20/*: any*/),
                          (v13/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": (v110/*: any*/),
                            "type": "TownsquareRisk"
                          }
                        ]
                      }
                    ]
                  },
                  (v50/*: any*/)
                ]
              },
              (v111/*: any*/)
            ]
          },
          {
            "condition": "isDecisionsTab",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              (v28/*: any*/),
              (v59/*: any*/),
              (v100/*: any*/),
              {
                "concreteType": "TownsquareHighlightConnection",
                "kind": "LinkedField",
                "name": "highlights",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TownsquareHighlightEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v20/*: any*/),
                          (v13/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": (v110/*: any*/),
                            "type": "TownsquareDecision"
                          }
                        ]
                      }
                    ]
                  },
                  (v50/*: any*/)
                ]
              },
              (v111/*: any*/)
            ]
          },
          {
            "condition": "isProjectsTab",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "concreteType": "TownsquareGoalCapabilities",
                "kind": "LinkedField",
                "name": "capabilities",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "canRemoveLinkedProjects"
                  },
                  {
                    "concreteType": "TownsquareGoalAppCapabilities",
                    "kind": "LinkedField",
                    "name": "apps",
                    "plural": false,
                    "selections": [
                      (v17/*: any*/)
                    ]
                  },
                  (v112/*: any*/)
                ]
              },
              {
                "args": (v113/*: any*/),
                "concreteType": "TownsquareProjectConnection",
                "kind": "LinkedField",
                "name": "projects",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TownsquareProjectEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      (v20/*: any*/),
                      (v51/*: any*/),
                      {
                        "concreteType": "TownsquareProject",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v20/*: any*/),
                          (v13/*: any*/),
                          (v114/*: any*/),
                          (v115/*: any*/),
                          (v117/*: any*/),
                          {
                            "concreteType": "TownsquareProjectUpdate",
                            "kind": "LinkedField",
                            "name": "latestUserUpdate",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareProjectPhaseDetails",
                                "kind": "LinkedField",
                                "name": "newPhase",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": "_id",
                                    "kind": "ScalarField",
                                    "name": "id"
                                  }
                                ]
                              },
                              (v13/*: any*/)
                            ]
                          },
                          (v87/*: any*/),
                          (v29/*: any*/),
                          (v59/*: any*/),
                          (v118/*: any*/),
                          (v119/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v52/*: any*/),
                  (v50/*: any*/)
                ],
                "storageKey": "projects(first:200,tql:\"archived = false\")"
              },
              (v120/*: any*/),
              {
                "concreteType": "TownsquareGoalConnection",
                "kind": "LinkedField",
                "name": "subGoals",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TownsquareGoalEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "TownsquareGoal",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v13/*: any*/),
                          (v87/*: any*/),
                          (v29/*: any*/),
                          (v60/*: any*/),
                          {
                            "concreteType": "TownsquareGoalType",
                            "kind": "LinkedField",
                            "name": "goalType",
                            "plural": false,
                            "selections": [
                              (v88/*: any*/),
                              (v13/*: any*/)
                            ]
                          },
                          {
                            "args": (v113/*: any*/),
                            "concreteType": "TownsquareProjectConnection",
                            "kind": "LinkedField",
                            "name": "projects",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareProjectEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareProject",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v13/*: any*/),
                                      (v87/*: any*/),
                                      (v29/*: any*/),
                                      (v59/*: any*/),
                                      (v118/*: any*/),
                                      (v114/*: any*/),
                                      (v119/*: any*/),
                                      (v115/*: any*/),
                                      (v20/*: any*/),
                                      (v117/*: any*/)
                                    ]
                                  },
                                  (v51/*: any*/),
                                  (v20/*: any*/)
                                ]
                              },
                              (v52/*: any*/),
                              (v50/*: any*/)
                            ],
                            "storageKey": "projects(first:200,tql:\"archived = false\")"
                          },
                          (v120/*: any*/),
                          {
                            "concreteType": "TownsquareGoalCapabilities",
                            "kind": "LinkedField",
                            "name": "capabilities",
                            "plural": false,
                            "selections": [
                              (v112/*: any*/)
                            ]
                          },
                          (v72/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "owner",
                            "plural": false,
                            "selections": [
                              (v20/*: any*/),
                              (v44/*: any*/),
                              (v65/*: any*/),
                              (v29/*: any*/),
                              (v13/*: any*/)
                            ]
                          },
                          (v97/*: any*/),
                          (v61/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v50/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "e980b42c3e7b17ffb2bfcac6e3408576937ef6e0808f9af61b03ee9a4dd538eb",
    "metadata": {},
    "name": "AggGoalTabContentQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "0e5b238307163b80676f6c59fb94bc80";

export default node;
